export default function(toggleClass = 'search-trigger', targetClass = 'banner__search-wrap') {
    $(`.${toggleClass}`).on('click', () => {
        $(`.${targetClass}`).toggleClass(`${targetClass}--active`);
        if( $(`.${targetClass}`).hasClass(`${targetClass}--active`) ){
            $('#search').focus();
        } else {
            $('#search').val('');
        }
        return false;
    });
}